<template>
  <transition
    appear
    :duration="1000"
  >
    <Flex
      :class="[$style.base, { [$style.smallScreen]: $screen === 's', [$style.smallPadding]: smallPadding }]"
      align="center"
      justify="center"
    >
      <Flex
        :class="$style.inner"
        direction="column"
        :gap="2"
      >
        <slot name="top" />
        <Flex
          :gap="2"
          :direction="$screen === 's' || $screen === 'm' ? 'column' : 'row'"
          justify="between"
          align="center"
        >
          <Flex
            direction="column"
            :gap="2"
            :justify="$props.centeredLeft ? 'center' : 'start'"
            fullHeight
          >
            <transition
              name="fade-slide-1"
              appear
            >
              <Flex
                direction="column"
                :class="$style.leftSection"
                :align="$screen === 's' ? 'center' : 'start'"
                :gap="1.5"
              >
                <slot name="left" />
              </Flex>
            </transition>
            <transition
              name="fade-slide-2"
              appear
            >
              <Flex
                :gap="1.5"
                direction="column"
                :class="$style.ctaSection"
                :align="$screen === 's' ? 'stretch' : 'start'"
              >
                <slot name="cta" />
                <Flex
                  :justify="$screen === 's' ? 'center' : 'start'"
                  :gap="1.5"
                >
                  <slot name="links" />
                </Flex>
              </Flex>
            </transition>
          </Flex>
          <transition
            name="fade-slide-4"
            appear
          >
            <slot name="right" />
          </transition>
        </Flex>
        <transition
          name="fade-slide-4"
          appear
        >
          <Flex
            direction="column"
            :gap="2"
            :justify="$props.centeredLeft ? 'center' : 'start'"
            fullHeight
          >
            <slot name="bottom" />
          </Flex>
        </transition>
      </Flex>
    </Flex>
  </transition>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  centeredLeft?: boolean;
  smallPadding?: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
  .base {
    min-height: 100%;
    background: 
      linear-gradient(to bottom left, rgba(3, 207, 165, 0.2) 0%, transparent 50%),
      linear-gradient(to top, rgba(76, 73, 197, 0.2) 0%, transparent 70%);

    &:not(.smallScreen) {
      min-height: 100%;
      padding: 80px $spacing * 2 $spacing * 3 $spacing * 2;

      &.smallPadding {
        padding: $spacing * 2;
      }
    }

    &.smallScreen {
      padding: $spacing * 2 $spacing $spacing * 10;
    }
  }
  .inner {
    max-width: 1200px;
    width: 100%;
    height: 100%;

    .base.smallScreen & {
      margin-top: $spacing * 2;
    }
  }
  .leftSection {
    .base.smallScreen & {
      & > * {
        text-align: center;
      }
    }
  }
  .ctaSection {
    .base.smallScreen & {
      z-index: 1;
      border-top: 1px solid var(--Typography-Placeholder, #dbdbdb);

      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      background-color: var(--color-bg);
      padding: $spacing $spacing 2 * $spacing;
    }
  }
</style>
